import React from 'react';
import {
  IonContent,
  IonPage,
  IonList,
  IonItem,
  IonLabel,
  IonIcon,
  IonButton,
  IonCard,
  IonCardHeader,
  IonCardTitle,
  IonCardContent,
} from '@ionic/react';
import {
  colorPaletteOutline,
  peopleOutline,
  imageOutline,
  qrCodeOutline,
} from 'ionicons/icons';
import DashboardLayout from '../components/Dashboard/DashboardLayout';

const Settings: React.FC = () => {
  return (
    <DashboardLayout>
      <IonPage>
        <IonContent className="ion-padding">
          <h1>Settings</h1>
          
          <IonCard>
            <IonCardHeader>
              <IonCardTitle>Branding</IonCardTitle>
            </IonCardHeader>
            <IonCardContent>
              <IonList>
                <IonItem>
                  <IonIcon icon={imageOutline} slot="start" />
                  <IonLabel>Company Logo</IonLabel>
                  <IonButton slot="end" fill="outline">Upload</IonButton>
                </IonItem>
                <IonItem>
                  <IonIcon icon={colorPaletteOutline} slot="start" />
                  <IonLabel>Color Scheme</IonLabel>
                  <IonButton slot="end" fill="outline">Customize</IonButton>
                </IonItem>
              </IonList>
            </IonCardContent>
          </IonCard>

          <IonCard>
            <IonCardHeader>
              <IonCardTitle>QR Code Settings</IonCardTitle>
            </IonCardHeader>
            <IonCardContent>
              <IonList>
                <IonItem>
                  <IonIcon icon={qrCodeOutline} slot="start" />
                  <IonLabel>Default QR Style</IonLabel>
                  <IonButton slot="end" fill="outline">Customize</IonButton>
                </IonItem>
              </IonList>
            </IonCardContent>
          </IonCard>

          <IonCard>
            <IonCardHeader>
              <IonCardTitle>Team Management</IonCardTitle>
            </IonCardHeader>
            <IonCardContent>
              <IonList>
                <IonItem>
                  <IonIcon icon={peopleOutline} slot="start" />
                  <IonLabel>Team Members</IonLabel>
                  <IonButton slot="end" fill="outline">Manage</IonButton>
                </IonItem>
              </IonList>
            </IonCardContent>
          </IonCard>
        </IonContent>
      </IonPage>
    </DashboardLayout>
  );
};

export default Settings; 